import { GroundTypes } from "../consts/GroundTypes";
import { Field } from "./Field";
import { Tower } from "./Tower";

export class GameMap {
    public readonly width = 11;
    public readonly height = 11;
    public fields: Array<Field>;
    public path: Array<[number, number]> = [];

    constructor() {
        this.fields = [... new Array(this.width * this.height)].map((_, index: number) => {
            return new Field(
                [index % this.width, Math.floor(index / this.width)]
            );
        });
        this.init_map();
    }

    private init_map() {
        this.init_path();
        this.init_towers();
    }

    private init_towers() {
        this.at(3, 5).tower = new Tower;
    }

    private init_path() {
        for (let i = 0; i < 9; ++i) {
            const p: [number, number] = [2, i];
            this.at(p[0], p[1]).ground = GroundTypes.PATH;
            this.path.push(p);
        }
        for (let i = 0; i < 7; ++i) {
            const p: [number, number] = [2 + i, 9];
            this.at(p[0], p[1]).ground = GroundTypes.PATH;
            this.path.push(p);
        }
        for (let i = 0; i < 9; ++i) {
            const p: [number, number] = [8, 8 - i];
            this.at(p[0], p[1]).ground = GroundTypes.PATH;
            this.path.push(p);
        }
    }


    public get_position_of_path(progress: number): [number, number] {
        if (progress < 0 || progress >= this.path.length - 1) throw new Error("out of path");
        const index = Math.floor(progress);
        const next_index = Math.ceil(progress);
        const start_position = this.path[index];
        const end_position = this.path[next_index];
        const fraction = progress - index;
        const inverse_fraction = 1 - fraction;
        return [
            start_position[0] * inverse_fraction + end_position[0] * fraction,
            start_position[1] * inverse_fraction + end_position[1] * fraction,
        ];
    }

    public at(x: number, y: number): Field {
        if (x < 0 || x >= this.width || y < 0 || y >= this.height) throw new Error("Not inside map");
        return this.fields[x + y * this.width];
    }
}